import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import PerfectScrollbar from 'perfect-scrollbar';

//DSS Documentation on Angular Reuse - http://tiny.sc/cgangularreuse
//DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
import { SocoConfigurationService } from '@soco/configuration';

import { AuthorizationService } from '../authorization.service';
import { ROUTES } from '../routes';

@Component({
    selector: 'sidebar',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    username$: Observable<string>;
    menuItems: any[];

    private unsubscribe$ = new Subject<void>();

    constructor(
        private authorizationService: AuthorizationService,
        private config: SocoConfigurationService
    ) { }

    ngOnInit() {
        //DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
        let usernameSettingName = 'Username';
        this.username$ = this.config.getSetting<string>(usernameSettingName);

        //request the current user's roles
        this.authorizationService.getCurrentUsersRoles()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(roles => {
                //filter out any menu items that require the user to have roles that the user doesn't have
                this.menuItems = ROUTES.filter(menuItem => roles.some(role => !menuItem.roles || menuItem.roles.length < 1 || menuItem.roles.includes(role)));
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    //=============================================================================================================
    //EVENT HANDLERS
    //=============================================================================================================
    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            let ps = new PerfectScrollbar(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
        }
    }

    //=============================================================================================================
    //HELPER FUNCTIONS
    //=============================================================================================================
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
}

